import {message, Space, Skeleton} from "antd";
import {useFormContext} from "react-hook-form";
import {FormFieldError} from "../../../../design-system/form-field";
import {
  useSessionCoverImagesDelete,
  useSessionUploadCoverImages,
  useCoverImagesWithFallback,
  mapDomainToEmbedded,
} from "../../../../features/media";
import {SessionCoverImagesFormFields} from "../../../../components/offering-form/session-bundle/session/cover-images";
import {useGetBundleContext} from "../context/get-bundle";
import {EditBundleBasicFormStepFormValues} from "../schema-validation";

export function EditBundleCoverImagesUpload() {
  const {
    state: {sessionData},
  } = useGetBundleContext();
  const {setValue, watch, formState} =
    useFormContext<EditBundleBasicFormStepFormValues>();
  const bundleUploadCoverImagesMutation = useSessionUploadCoverImages();
  const bundleCoverImagesDeleteMutation = useSessionCoverImagesDelete();

  // Fetch cover images via v2 with fallback to embedded data
  const {coverImages, isLoading: isCoverImagesLoading} = useCoverImagesWithFallback({
    offeringType: "service", // bundles are service type
    offeringId: sessionData.id,
    embedded: sessionData.cover_images,
  });

  // Convert domain format back to API format for existing component
  const coverImagesForDisplay = mapDomainToEmbedded(coverImages);

  function handleCoverImagesItemDelete({
    mediaId,
    offeringId,
  }: {
    mediaId: string;
    offeringId: number;
  }) {
    bundleCoverImagesDeleteMutation.mutate(
      {mediaId, offeringId},
      {
        onSuccess: () => {
          const currentCoverImages = watch("cover_images");

          const newValues = currentCoverImages.filter((x) => x.id !== mediaId);
          // console.log({currentCoverImages, newValues});
          setValue("cover_images", newValues);
          message.success("Deleted successfully");
        },
      }
    );
  }

  // Show loading skeleton while fetching cover images
  if (isCoverImagesLoading) {
    return (
      <div>
        <Space size={16} direction="vertical" style={{display: "flex"}}>
          <Skeleton.Image active style={{width: 200, height: 120}} />
        </Space>
      </div>
    );
  }

  return (
    <div>
      <Space size={16} direction="vertical" style={{display: "flex"}}>
        <SessionCoverImagesFormFields
          accordionIndex={0}
          sessionData={{
            id: sessionData.id,
          }}
          defaultCoverImages={coverImagesForDisplay}
          deleteCoverImage={handleCoverImagesItemDelete}
          isDeleteLoading={bundleCoverImagesDeleteMutation.isLoading}
          isUploadLoading={bundleUploadCoverImagesMutation.isLoading}
          offeringId={sessionData.id}
          uploadCoverImages={bundleUploadCoverImagesMutation}
        />
        <FormFieldError errorMessage={formState.errors.cover_images?.message} />
      </Space>
    </div>
  );
}
